import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import SelectField from './SelectField'
import TextField from './TextField'

const Dates = () => {
  return (
    <Box width="full" gap="s24" flexDirection="row">
      <TextField
        title={i18n.t('contract_versions.flows.fix.steps.role_level_salary.base_salary.label')}
      />
      <SelectField
        title={i18n.t('contract_versions.flows.fix.steps.role_level_salary.salary_frequency.label')}
      />
    </Box>
  )
}

export default Dates
